import React from 'react'
import AppModal from '../../../components/organisms/CustomModal'

const EditFees = (props) => {
    return (
        <AppModal
            handleClose={() => props.setModalState(false)}
            modalStyle="desktop:w-2/5 w-3/4 mobile:w-[85%] min-h-screen z-30 top-0 bg-Background5 right-0 left-0 mx-auto animate-slide_down shadow-[0_8px_30px_rgb(0,0,0,0.12)] transition-all"
            closeBtnStyle="hidden"
        >
            Coming soon...
        </AppModal>
    )
}

export default EditFees